import type { SVGProps } from 'react';

const SvgDeletionErase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="m13.41 12.022 2.29-2.29a.996.996 0 1 0-1.41-1.41L12 10.612l-2.29-2.29a.996.996 0 1 0-1.41 1.41l2.29 2.29-2.29 2.29a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l2.29-2.29 2.29 2.29c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41l-2.29-2.29z"
    />
  </svg>
);
export default SvgDeletionErase;
